import useEventCallback from '@unifyapps/hooks/useEventCallback';
import _forEach from 'lodash/forEach';
import _isEmpty from 'lodash/isEmpty';
import { useCallback } from 'react';
import { useRouter } from './useRouter';

//todo: remove these utils post setBlockQueryParams feature is added by Prakhar
const convertPayloadToString = (payload: unknown) => {
  if (typeof payload === 'object') {
    return JSON.stringify(payload);
  }
  if (typeof payload === 'string') {
    return payload;
  }
  return '';
};

export const createQueryParams = (
  queryParams: Record<string, Record<string, unknown> | string | undefined | null>,
) => {
  const searchParams = new URLSearchParams();

  _forEach(queryParams, (value, key) => {
    if (_isEmpty(value)) {
      return;
    }
    searchParams.set(key, convertPayloadToString(value));
  });

  return searchParams.toString();
};

export const useQueryParams = () => {
  const router = useRouter();

  const getQueryParam = useCallback(
    (key: string) => router.searchParams.get(key),
    [router.searchParams],
  );

  const setQueryParam = useEventCallback((key: string, value: string | undefined | null) => {
    const state = router.getState?.();
    const pathName = state?.pathname;
    if (!pathName) return;
    const query = createQueryParams({
      ...Object.fromEntries(state.searchParams),
      [key]: value,
    });
    // skip same-URL replaces. block methods like CopilotChatPanel.GoToChat get
    // fired by no-code action wirings on every data-source OnSuccess event
    // (see useExecuteDataSourceCallbacks.useEffect → emitEvent → executeAction),
    // typically with the same chatId already in the URL. without this guard each
    // invocation would still hit router.replace and trigger a fresh _rsc payload
    // fetch — surfacing as the copilot panel "reloading multiple times".
    if (query === state.searchParams.toString()) return;
    router.replace(query ? `${pathName}?${query}` : pathName);
  });

  return { getQueryParam, setQueryParam };
};
